export function beforeAfterEvents() {
	const containers = document.querySelectorAll(".before-after-toggle");
	if (!containers.length) return;
	containers.forEach((container) => {
		async function onFirstClick(e) {
			container.removeEventListener("click", onFirstClick);
			try {
				const { initBeforeAfters } = await import("./before-after.js");
				const toggleBeforeAfters = initBeforeAfters(container);
				toggleBeforeAfters(e);
			} catch (err) {
				console.error("Failed to load module:", err);
			}
		}
		container.addEventListener("click", onFirstClick);
	});
}
